import mixpanel, { Mixpanel } from 'mixpanel-browser';

interface UseMixpanelProps {
    mixpanel: Mixpanel,
}

const useMixpanel: (token: string) => UseMixpanelProps = (token: string) => {
    const mxInst = mixpanel.init(token,
        {
            api_host: "https://api-eu.mixpanel.com",
        },
        'website_billing'
    );
    return { mixpanel: mxInst };
}

export default useMixpanel